import { render, staticRenderFns } from "./select-items.vue?vue&type=template&id=33415673&scoped=true&"
import script from "./select-items.vue?vue&type=script&lang=js&"
export * from "./select-items.vue?vue&type=script&lang=js&"
import style0 from "./select-items.vue?vue&type=style&index=0&id=33415673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33415673",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VBtn,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemIcon})
